import { useEffect } from 'react';

import { useHomeGamesWidget } from '@swf/poker';

const useResetStoreOnUnmount = () => {
  const { widgetDispatch } = useHomeGamesWidget();

  // Reset to initial state on unmount
  useEffect(
    () => () => {
      widgetDispatch.reset();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
};

export default useResetStoreOnUnmount;
